<template>
  <div class="emd-dropdown _position_right" ref="userMenu" v-click-outside="clickedOutside">
    <div class="emd-dropdown__trigger" @click="toggleUserMenu" :class="{ '_active': showUserMenu }">
        <span>
          <emd-tippy id="profile" tag="button" class="emd-action-button _has-tooltip"  :type="'action-button'" :content="$t('profile')">
            <i class="emd-action-button__icon uil uil-user"></i>
            <i class="emd-action-button__arrow uil uil-angle-down"></i>
          </emd-tippy>
        </span>
    </div>
    <div class="emd-dropdown__content" :class="{'_active': showUserMenu}">
      <div class="emd-dropdown__content__item">
        <span class="emd-badge eu-mt_1">{{ permission }}</span>
        <div class="emd-text _color_default _type_label _size_tiny eu-ma_2">{{$t('profile')}}</div>
      </div>
      <ul>
        <li class="emd-dropdown__content__item">
          <a class="emd-text _color_default" :href="urlProfile">
            <p class="emd-dropdown__content__item__text">
              <span class="emd-text _color_nonessential">
                <i class="uil uil-user"></i>
              </span>
              <span>{{user.first_name}} {{user.last_name}}</span>
            </p>
          </a>
        </li>
        <li class="emd-dropdown__content__item">
          <a class="emd-text _color_danger" href="javascript:void(0)" @click="triggerLogout">
            <p class="emd-dropdown__content__item__text">
              <i class="uil uil-sign-out-alt"></i>
              <span>{{$t('logout')}}</span>
            </p>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<i18n>
{
  "pt-BR": {
    "logout": "Sair",
    "profile": "Perfil"
  },
  "en-US": {
    "logout": "Logout",
    "profile": "Profile"
  }
}
</i18n>

<script>
import EmdTippy from '@/components/emerald/atoms/EmdTippy'

export default {
  name: 'EmdUserMenu',
  components: {
    EmdTippy
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    isEmployee () {
      return this.$store.getters.isEmployee
    },
    merchant () {
      return this.$store.getters.merchantData
    },
    urlProfile () {
      return process.env.VUE_APP_PROFILE_URL
    },
    userType () {
      return this.$store.getters.userType
    },
    userRole () {
      return this.$store.getters.userRole
    },
    permission () {
      const type = this.userType.key.toLowerCase()
      if (this.isEmployee || type === 'owner' || type === 'admin') {
        return this.userType.value
      } else {
        return this.userRole.value
      }
    }
  },
  data () {
    return {
      showUserMenu: false
    }
  },
  methods: {
    toggleUserMenu () {
      this.showUserMenu = !this.showUserMenu
    },
    clickedOutside (e) {
      if (!this.$refs.userMenu.contains(e.target) && this.showUserMenu) {
        this.toggleUserMenu()
      }
    },
    triggerLogout () {
      this.$store.dispatch('toggleGlobalLoading', true)
      this.$store.dispatch('DELETE_AUTHORIZATION', true)
      window.location.assign(process.env.VUE_APP_DEFAULT_REDIRECT)
    }
  }
}
</script>
